import Vue from "vue";
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";

const state = {
    loading: true,
    init: false,
    admin: false,
    adminName: 'Guest',
    compare: {
        used: [],
        new: [],
        motability: [],
    },
    brand: 'randd',
    usedCars: {},
    usedRefineSearch: false,
    showSaveCompare: false,
    includeSocialMedia: false,
    showLiveChat: true,
    telephone: '024 7685 1458',
    reusableFAQs: {},
};

const getters = {
    compareCount(state) {
        return state.compare.used.length + state.compare.new.length + state.compare.motability.length;
    },
    compareLink(state) {
        if (state.compare.used.length >= state.compare.new.length) {
            return { name: 'saved-vehicles', params: { type: 'used' } };
        }
        return { name: 'saved-vehicles', params: { type: 'new' } };
    },
    brand(state) {
        return state.brand;
    },
    usedRefineSearch(state) {
        return state.usedRefineSearch;
    },
    includeSocialMedia(state) {
        return state.includeSocialMedia;
    },
    telephone(state) {
        return state.telephone;
    },
    showLiveChat(state) {
        return state.showLiveChat;
    },
};

const actions = {
    initialize({ commit, state, getters, dispatch }, brand) {
        // Don't collect data again if init is done
        if (state.init) {
            return;
        }
        commit('setLoading', true);
        axios.post('/api/layout')
            .then(response => {
                commit('setLoading', false);
                commit('setInit', true);
                commit('setData', response.data);
                commit('setCompare', response.data.compare);
            })
            .catch(e => {
                commit('setLoading', false);
            });
    },
    saveVehicle({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('/saved-vehicles/add_remove', {
                type: data.type,
                id: data.id,
                // value is actually just a string flag to add/remove the vehicle
                // Not sure why it was called value rather than a meaningful name
                value: (data.add == true) ? 'true' : 'false',
            })
            .then(response => {
                customEvent('Saved Vehicles', 'Used Vehicle Added', 'Added');
                commit('setCompare', response.data);
                resolve(response.data);
            })
            .catch(e => {
                console.error(e);
                reject(e);
            });
        });
    },
    getReusableFAQ({ commit, state }, page) {
        return new Promise((resolve, reject) => {
            if (typeof state.reusableFAQs[page] != 'undefined') {
                resolve(state.reusableFAQs[page]);
                return;
            }

            axios.get('/api/reusable-faqs', {
                params: {
                    page: page,
                }
            })
            .then(response => {
                commit('setReusableFaqPage', {
                    page: page,
                    faq: response.data,
                });
                resolve(response.data);
            })
            .catch(e => {
                console.error(e);
                reject(e);
            });
        });
    }
};
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setCompare(state, compare) {
        let usedCars = (compare.used) ? Object.keys(compare.used) : [];
        let newCars = (compare.new) ? Object.keys(compare.new) : [];
        let motability = (compare.motability) ? Object.keys(compare.motability) : [];
        Vue.set(state.compare, 'used', usedCars);
        Vue.set(state.compare, 'new', newCars);
        Vue.set(state.compare, 'motability', motability);
    },
    setBrand(state, brand) {
        state.brand = brand;
    },
    setInit(state, init) {
        state.init = init;
    },
    setUsedRefineSearch(state, val) {
        state.usedRefineSearch = val;
    },
    setShowSaveCompare(state, val) {
        state.showSaveCompare = val;
    },
    setData(state, data) {
        if (data.admin) {
            state.admin = true;
            if (data.adminName) {
                state.adminName = data.adminName;
            }
        }
    },
    setReusableFaqPage(state, faqAndPage) {
        Vue.set(state.reusableFAQs, faqAndPage.page, faqAndPage.faq);
    },
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

